import { render, staticRenderFns } from "./WameedFilterHeader.vue?vue&type=template&id=1bff973f&"
import script from "./WameedFilterHeader.vue?vue&type=script&lang=js&"
export * from "./WameedFilterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports